export const languageEnum = {
    English: "en",
    Arabic: 'ar',
}
export const pageSize = 50